import { render, staticRenderFns } from "./ModalSelecaoTipoAssinaturaGenerico.vue?vue&type=template&id=48c075ba&scoped=true"
import script from "./ModalSelecaoTipoAssinaturaGenerico.vue?vue&type=script&lang=js"
export * from "./ModalSelecaoTipoAssinaturaGenerico.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecaoTipoAssinaturaGenerico.vue?vue&type=style&index=0&id=48c075ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c075ba",
  null
  
)

export default component.exports